import React from 'react';
import Modal from '@mui/material/Modal';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box'; // Import Box for centering the modal
import Grid from '@mui/material/Grid'; // Import Grid for button layout
import '../App.css';

const ConfirmationModal = ({ isOpen, message, onConfirm, onCancel }) => {
    return (
        <Modal
            open={isOpen}
            onClose={onCancel}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                }}
            >
                <div className="text-center">
                    <ReportProblemRoundedIcon className='confirmation-icon' />
                    <h2>Confirmation</h2>
                    <p>{message}</p>

                    {/* Use Grid for equal-width buttons */}
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={onConfirm}
                                fullWidth // Ensure button takes the full width of the grid item
                            >
                                Yes
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button 
                                variant="outlined" 
                                color="secondary" 
                                onClick={onCancel}
                                fullWidth // Ensure button takes the full width of the grid item
                            >
                                No
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Box>
        </Modal>
    );
};

export default ConfirmationModal;
